// ─────────────────────────────────────────────────────────────
// riskScenariosReducer.js – transient “variant” lists
//   state shape:
//   {
//     _loading : boolean,
//     _error   : string | null,
//     [modelId]: {
//       [riskArea]: {
//         [sourceName]: Scenario[]        // each { riskId, variantText, … }
//       }
//     }
//   }
// ─────────────────────────────────────────────────────────────
import {
  /* fetch */
  FETCH_RISK_SCENARIOS_START,
  FETCH_RISK_SCENARIOS_SUCCESS,
  FETCH_RISK_SCENARIOS_FAILURE,
  /* refine */
  REFINE_SCENARIO_START,
  REFINE_SCENARIO_SUCCESS,
  REFINE_SCENARIO_FAILURE,
  /* promote / clear */
  MOVE_SCENARIO_TO_RISKS,
  CLEAR_SCENARIOS,
} from '../actions/actionTypes';

const initialState = {
  _loading: false,
  _error  : null,
};

export default function riskScenarios(state = initialState, action) {
  switch (action.type) {
    /* ─────────────── FETCH LIST ─────────────── */
    case FETCH_RISK_SCENARIOS_START:
      return { ...state, _loading: true, _error: null };

    case FETCH_RISK_SCENARIOS_SUCCESS: {
      const { modelId, riskArea, sourceName, scenarios } = action.payload;
      return {
        ...state,
        _loading: false,
        [modelId]: {
          ...(state[modelId] || {}),
          [riskArea]: {
            ...(state[modelId]?.[riskArea] || {}),
            [sourceName]: scenarios,
          },
        },
      };
    }

    case FETCH_RISK_SCENARIOS_FAILURE:
      return { ...state, _loading: false, _error: action.payload.error };

    /* ─────────────── REFINE ONE ─────────────── */
    case REFINE_SCENARIO_START:
      return { ...state, _loading: true, _error: null };

    case REFINE_SCENARIO_SUCCESS: {
      const { modelId, riskArea, sourceName, scenario } = action.payload;
      const prev = state[modelId]?.[riskArea]?.[sourceName] || [];
      return {
        ...state,
        _loading: false,
        [modelId]: {
          ...state[modelId],
          [riskArea]: {
            ...state[modelId][riskArea],
            [sourceName]: prev.map(s =>
              s.scenarioId === scenario.scenarioId ? scenario : s
            ),
          },
        },
      };
    }

    case REFINE_SCENARIO_FAILURE:
      return { ...state, _loading: false, _error: action.payload.error };

    /* ──────────── PROMOTE / CLEAR ───────────── */
    case MOVE_SCENARIO_TO_RISKS:
    case CLEAR_SCENARIOS: {
      const { modelId, riskArea, sourceName } = action.payload;
      /* deep-clone only the part we touch */
      const next = JSON.parse(JSON.stringify(state));
      delete next[modelId]?.[riskArea]?.[sourceName];

      // tidy empty shells
      if (next[modelId]?.[riskArea] && !Object.keys(next[modelId][riskArea]).length)
        delete next[modelId][riskArea];
      if (next[modelId] && !Object.keys(next[modelId]).length)
        delete next[modelId];

      next._loading = false;
      next._error   = null;
      return next;
    }

    default:
      return state;
  }
}